import { Flex } from "rebass/styled-components";
import styled, { css } from "styled-components";
import { SubStatus } from "core-integration/src/store/my-team/types";
import { rgba } from "polished";
import PitchSvg from "../img/as-pitch.svg";

const Pitch = styled.div`
  min-height: 330px;
  background-image: url(${PitchSvg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 516px 330px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    min-height: 524px;
    background-size: 820px 524px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    min-height: 690px;
    background-size: 1080px 690px;
  }
`;

export const ElementRow = styled(Flex)`
  max-width: 410px;
  margin: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    max-width: 620px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    max-width: none;
  }
`;

export const PitchRow = styled(ElementRow)`
  padding-bottom: 0.1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-bottom: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-bottom: ${({ theme }) => theme.space[5]};
  }
`;

export const PitchUnit = styled.div`
  flex: 1;
  min-height: 7.2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    min-height: 9.6rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    min-height: 11.6rem;
  }
`;

export const PitchElementWrap = styled.div<IWrapStyleProps>`
  margin: 0 0.2rem;
  padding: 0.4rem 0;
  border-radius: 0.4rem;
  align-items: stretch;
  ${(props) =>
    (props.variant === "instigator" || props.variant === "target") &&
    css`
      transition: all 0.15s;
      box-shadow: 0 0 0.6rem 0 rgba(0, 0, 0, 0.4);
    `}

  ${(props) =>
    props.variant === "instigator" &&
    css`
      background-color: ${rgba("yellow", 0.6)};
    `}

  ${(props) =>
    props.variant === "target" &&
    css`
      background-color: ${rgba("#f60", 0.6)};
    `}

  ${(props) =>
    props.variant === "invalid" &&
    css`
      opacity: 0.6;
    `}
`;

export const StyledPitchElement = styled.div<IPitchElementStyleProps>`
  position: relative;
  width: 6.4rem;
  height: 7.4rem;
  margin: auto;
  padding: ${({ theme }) => theme.space[1]} 0 0 0;
  border: ${({ theme }) => theme.borders[4]};
  border-radius: ${({ theme }) => theme.radii[1]};
  background: ${({ theme }) => theme.colors.green06};
  backdrop-filter: blur(2px);
  box-shadow: 0 0 11px 0 ${({ theme }) => theme.colors.greyDark04};
  text-align: center;
  opacity: ${(props) => (props.isRemoved ? "0.8" : "1")};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 11rem;
    height: 12.4rem;
    padding: ${({ theme }) => theme.space[2]} 0 0 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: 1.1rem 0 0 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 12rem;
    height: 14.8rem;
    padding: ${({ theme }) => theme.space[4]} 0 0 0;
  }
`;

export const Controls = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: block;
  }
`;

export const PrimaryControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    left: ${({ theme }) => theme.space[1]};
    top: ${({ theme }) => theme.space[1]};
  }
`;

export const InfoControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    right: ${({ theme }) => theme.space[1]};
    top: ${({ theme }) => theme.space[1]};
  }
`;

interface IWrapStyleProps {
  variant?: SubStatus;
}

interface IPitchElementStyleProps {
  isRemoved?: boolean;
}

export default Pitch;
